import { AdhocHoldOfCntrConstant } from "presentation/constant/AdhocHoldOfContainer/AdhocHoldOfCntrConstant";
import { useAdhocHoldOfCntrVM } from "presentation/hook/AdhocHoldOfContainer/useAdhocHoldOfCntrVM";
import { useAdhocHoldOfCntrTracked } from "presentation/store/AdhocHoldOfContainer/AdhocHoldOfCntrProvider";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import { memo, useCallback } from "react";
import { HPHButton, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const AdhocHoldOfCntrTitleBar: React.FC = () => {
    const [adhocHoldOfCntrState] = useAdhocHoldOfCntrTracked();
    const adhocHoldOfCntrVM = useAdhocHoldOfCntrVM();
    // const [isLoading] = useState(false);
    const { selectedRows, isLoading } = adhocHoldOfCntrState;
    const [anaInfoState] = useANAInfoTracked();

    const { allowUpdate } = anaInfoState;

    const handleSearch = useCallback(async () => {
        adhocHoldOfCntrVM.onSearchClick();
    }, [adhocHoldOfCntrVM]);

    const handleHold = useCallback(async () => {
        adhocHoldOfCntrVM.onHoldClicked();
    }, [adhocHoldOfCntrVM]);

    return <Sidebarheader style={{ width: '100%', display: "flex", alignItems: "center" }}>
        <HeaderTitle>{AdhocHoldOfCntrConstant.TITLE}</HeaderTitle>
        {(isLoading) && <Loader Indicator="Spinner" size="Medium" />}
        <StyledAction className="tm-animated-wrapper">
            <IconButton fileName='Icon-search' disabled={false} size='medium' toolTipText={'Search'} toolTipArrow={false} onClick={handleSearch} />
            {allowUpdate && <HPHButton label={"Hold"} size={'Small'} disabled={selectedRows.length === 0} theme={'Primary'} onClick={handleHold} />}
        </StyledAction>
        {adhocHoldOfCntrState.forceRefresh && <></>}
    </Sidebarheader>
}

export default memo(AdhocHoldOfCntrTitleBar);